import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: flex-end;
`;
